import { post } from "@/api";
import type {
  IInitializePaymentResponse,
  InitializeRequest,
} from "@/api/interfaces/paymentLayouts";
import { PaymentPath } from "@/api/paths";
import type { ApiRequest, RequestResponse } from "@/api/types";

const initialize: ApiRequest<
  RequestResponse<IInitializePaymentResponse>,
  InitializeRequest
> = async ({ barcodeWithoutChecksum, ...options }) =>
  post({
    ...options,
    api: PaymentPath.initialize(barcodeWithoutChecksum),
  });

const Payment = {
  initialize,
};

export default Payment;
